import { useMutation } from '@tanstack/react-query';
import { resetPassword } from './api';

export const useResetPasswordMutation = () =>
  useMutation({ mutationFn: resetPassword });
